export default __webpack_public_path__ + "static/media/importarXLSXHelp.14016846.svg";